<script setup lang="ts">
import { checkUrlIsExternal } from '@/utils/checkUrlIsExternal'

import { useCityStore } from '@/store/city/city'

import FooterLinksList from '@/components/Footer/footer-links/FooterLinksList.vue'

const { findCompanyLinks } = useCityStore()

const links = computed(() => {
  if (!findCompanyLinks) return []

  const list = []

  for (const content of findCompanyLinks.items) {
    const isLinkExternal = checkUrlIsExternal(content.link)

    list.push({
      title: content.label,
      path: content.link,
      rel: isLinkExternal ? 'nofollow noopener' : '',
      target: isLinkExternal ? '_blank' : '_self',
    })
  }

  return list
})
</script>

<template>
  <footer-links-list :links="links" />
</template>
